import { momentModule } from '../vendor/moment';
import { padNum } from '../utils/string-utils';

export const secondsToTimeFilterModule = angular
  .module('Q.filters.seconds-to-time', [momentModule])

  .filter('secondsToTime', (moment) => {
    return (seconds) => {
      const d = moment.duration(seconds || 0, 's');
      return `${Math.floor(d.asHours())}:${padNum(d.minutes())}:${padNum(d.seconds())}`;
    };
  });
